import { useCallback } from 'react';
import type { ValueViewerProps } from 'common/types/scalarSpreadsheet';
import type { MappingReference } from 'components/ScalarSpreadsheet/hooks';
import FastValueViewer from 'components/ScalarSpreadsheet/utilities/FastValueViewer';
import { EventType, useEventBus } from 'context';

const CrossReferencePopupReferencesViewer = (props: ValueViewerProps) => {
  const { cell } = props;
  const { mappingReferences } = cell as ValueViewerProps['cell'] & { mappingReferences?: MappingReference[] };
  const { publish } = useEventBus();

  const handleClick = useCallback(
    (e: React.MouseEvent | React.KeyboardEvent) => {
      e.stopPropagation();
      const first = mappingReferences?.[0];
      if (!first) {
        return;
      }
      const documentReferenceId = Number(first.document_reference);
      if (!Number.isFinite(documentReferenceId)) {
        return;
      }
      publish(EventType.NAVIGATE_TO_DOCUMENT_REFERENCE, {
        documentReferenceId,
        sheetName: first.sheet_name,
        expandDrawer: true,
      });
    },
    [mappingReferences, publish]
  );

  const handleKeyDown = useCallback(
    (e: React.KeyboardEvent) => {
      if (e.key === 'Enter' || e.key === ' ') {
        e.preventDefault();
        handleClick(e);
      }
    },
    [handleClick]
  );

  return (
    <div onClick={handleClick} onKeyDown={handleKeyDown} role="button" tabIndex={0}>
      <FastValueViewer {...props} />
    </div>
  );
};

export default CrossReferencePopupReferencesViewer;
